/* Implementation of the presentation of the audio player */
import { useRef, useState, useEffect } from 'react';
import './AudioSlider.scss';
import instrumental from '../assets/audio/eye_contact_student_instrumental.mp3';
import pauseButton from '../assets/image/pause_circle_icon@3x.png';
import { shallowEqual, useSelector } from 'react-redux';
import MediaService from '../../../../services/MediaService';

const AudioSlider = ({audioSrc, recordingSrc }) => {
  const [playing, setPlaying] = useState(true);
  const [audio1Ready, setAudio1Ready] = useState(false);
  const [audio2Ready, setAudio2Ready] = useState(false);

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const playIconContainer = useRef();
  const audioPlayerContainer = useRef();
  const seekSlider = useRef();
  const audio = useRef();
  const recording = useRef();
  const currentTimeContainer = useRef();
  const durationTimeContainer = useRef();

  let rAF = null;

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }


  const handlePlayButton = async () => {
    audio.current.volume = 0.6;
    recording.current.volume = 1;
    if (playing) {
      recording.current.play();
      audio.current.play();
      requestAnimationFrame(whilePlaying);
      setPlaying(false);
    } else {
      recording.current.pause();
      audio.current.pause();
      cancelAnimationFrame(rAF);
      setPlaying(true);
    }
    await sleep(2000);
    if(recording.current.currentTime !== audio.current.currentTime) {
      // console.log('recording', recording.current.currentTime, 'audio', audio.current.currentTime)
      audio.current.currentTime = recording.current.currentTime;
    }
    // console.log('After recording', recording.current.currentTime, 'After audio', audio.current.currentTime)

  };

  const showRangeProgress = (rangeInput) => {
    if (rangeInput === seekSlider.current) {
      audioPlayerContainer.current.style.setProperty(
        '--seek-before-width',
        (rangeInput.value / rangeInput.max) * 100 + '%'
      );
    } else {
      audioPlayerContainer.current.style.setProperty(
        '--volume-before-width',
        (rangeInput.value / rangeInput.max) * 100 + '%'
      );
    }
  };

  /* Implementation of the functionality of the audio player */

  const playIcon = MediaService.getImage(
    '/Module1Images/Play-small_3x.png',
    login
  );

  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
  };

  const displayDuration = () => {
    durationTimeContainer.current.textContent = calculateTime(
      audio.current.duration
    );
  };

  const setSliderMax = () => {
    seekSlider.current.max = Math.floor(audio.current.duration);
  };

  const whilePlaying = () => {
    seekSlider.current.value = Math.floor(audio.current.currentTime);

    currentTimeContainer.current.textContent = calculateTime(
      seekSlider.current.value
    );

    audioPlayerContainer.current.style.setProperty(
      '--seek-before-width',
      `${(seekSlider.current.value / seekSlider.current.max) * 100}%`
    );

    rAF = requestAnimationFrame(whilePlaying);
  };

  const handleSeekInput = (e) => {
    showRangeProgress(e.target);

    currentTimeContainer.current.textContent = calculateTime(seekSlider.value);

    if (!audio.current.paused) {
      cancelAnimationFrame(rAF);
    }
  };

  const handleTimeUpdate = () => {
    seekSlider.current.value = Math.floor(audio.current.currentTime);
  };

  const handleSeekChange = (e) => {
    audio.current.currentTime = seekSlider.current.value;
    recording.current.currentTime = seekSlider.current.value;

    if (!audio.current.paused) {
      requestAnimationFrame(whilePlaying);
    }
  };

  const onAudioLoadedMetadata = () => {
    displayDuration();
    setSliderMax();
  };

  return (
    <div id='audio-player-container' ref={audioPlayerContainer}>
      <audio
        onCanPlayThrough={() => {
          setAudio1Ready(true);
        }}
        ref={audio}
        onLoadedMetadata={onAudioLoadedMetadata}
        src={audioSrc}
        preload='metadata'
        onEnded={handlePlayButton}
      ></audio>

      <audio  ref={recording} src={recordingSrc} onCanPlayThrough={() => {
              setAudio2Ready(true);
            }}></audio>
      {audio1Ready && audio2Ready && <button ref={playIconContainer} onClick={handlePlayButton}>
        <img alt='play pause' src={playing ? playIcon : pauseButton} />
      </button>}
      <input
        type='range'
        ref={seekSlider}
        max='100'
        value='0'
        onInput={handleSeekInput}
        onChange={handleSeekChange}
      />
      <div className='time'>
        <span id='current-time' ref={currentTimeContainer}>
          0:00
        </span>
        /<span ref={durationTimeContainer}></span>
      </div>
    </div>
  );
};

export default AudioSlider;
